import React, { useEffect } from "react";

const PanelSkinMiniBox = (props) => {
  const [status, setStatus] = React.useState(props.active);

  useEffect(() => {
    if (props.active == status) return;
    setStatus(props.active);
  }, [props.active]);

  const index = props.skin.market_name.lastIndexOf("(");
  let name, packageName;
  if (index > -1) {
    name = props.skin.market_name.substring(0, index);
    packageName = props.skin.market_name.substring(index);
  } else {
    name = props.skin.market_name;
  }

  const ToggleStatus = () => {
    props.SelectedSkinsHandler(!status, props.skin);
    setStatus(!status);
  };

  const ToggleStatusDivHandler = () => {
  	if(!status){
	    props.SelectedSkinsHandler(true, props.skin);
	    setStatus(true);
  	}
  }

  return (
    <div className={"panel-skin-box" + (!status ? " disabled" : "")} onClick={() => { !props.skin.disabled_reason ? ToggleStatusDivHandler() : null }}>
      <div className="panel-skin-box-top">
        <h2>{name}</h2>
        <h3>{packageName}</h3>
        <img src={props.skin.image} />
        <div className={"disabled-reason " + (!props.skin.disabled_reason ? "active" : "")}>
          {props.skin.disabled_reason}
          {!props.skin.disabled_reason && status ? (
            <div className="mini-toggle-button" onClick={ToggleStatus}>
              Çıkar
            </div>
          ) : !props.skin.disabled_reason && (
            <div className="mini-toggle-button">
              Ekle
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PanelSkinMiniBox;
